/**
 * Handschutzplan-Modul · Baustein 5 (Aug 2026) — gemeinsame UI-Helfer
 * für Übersichts- und Detailseite.
 */

export const KATEGORIE_LABELS = {
  hautschutz: "Hautschutz",
  handschuhe: "Handschuhe",
  haende_desinfizieren: "Hände desinfizieren",
  haende_waschen: "Hände waschen",
  haende_pflegen: "Hände pflegen",
};

export function formatDateDe(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// Rein informativ aus dem gespeicherten Datum (Betreiberfreigabe 4a.iv) —
// ISO-Daten (YYYY-MM-DD) sind lexikographisch vergleichbar.
export function istPruefungFaellig(plan) {
  const due = plan?.naechste_pruefung_faellig_am;
  if (!due) return false;
  return String(due).slice(0, 10) <= new Date().toISOString().slice(0, 10);
}

// Baustein 7 (Betreiberfreigabe 2a): Vorwarnfenster 30 Tage — identische
// Schwelle wie die Unterweisungs-Fälligkeiten im Dashboard.
export function istPruefungBaldFaellig(plan) {
  const due = plan?.naechste_pruefung_faellig_am;
  if (!due || istPruefungFaellig(plan)) return false;
  const grenze = new Date();
  grenze.setDate(grenze.getDate() + 30);
  return String(due).slice(0, 10) <= grenze.toISOString().slice(0, 10);
}

// Dezenter Hinweis, wenn für die JÜNGSTE Generierung kein WORM-Beleg
// vorliegt (Freigabe 2a: best-effort, `last_worm_*` behält den letzten
// erfolgreichen Zeugen).
export function fehltAktuellerBeleg(plan) {
  if (!plan?.generated_at) return false;
  const archived = plan.last_worm_archived_at;
  if (!archived) return true;
  return archived < plan.generated_at;
}

// Statuscode-Mapping der Trigger-Route (Baustein 4, Freigabe 4a) in
// verständliche Owner-Meldungen. Guard-/Prüf-Details werden durchgereicht.
export function generateFehlerMeldung(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (status === 422) {
    return (
      detail ||
      "Der generierte Plan hat die Qualitätsprüfung nicht bestanden — bitte erneut versuchen."
    );
  }
  if (status === 403 || status === 429 || status === 503) {
    return detail || "Die KI-Generierung ist derzeit blockiert.";
  }
  if (status === 502) {
    return "Die KI ist derzeit nicht erreichbar — bitte später erneut versuchen.";
  }
  if (status === 404) {
    return "Einsatzbereich nicht gefunden oder archiviert.";
  }
  return "Die Generierung ist fehlgeschlagen — bitte später erneut versuchen.";
}
